import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Users, ArrowRight, Mail, Phone, Briefcase } from 'lucide-react';
import { Logo } from '../components/Logo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Employees() {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/employees`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmployees(response.data);
    } catch (err) {
      console.error('Error fetching employees:', err);
    }
  };

  const getRoleName = (role) => {
    const roles = {
      lawyer: 'محامي',
      accountant: 'محاسب',
      staff: 'موظف إداري',
    };
    return roles[role] || role;
  };

  return (
    <div className="min-h-screen bg-sand" dir="rtl" lang="ar">
      <header className="bg-primary py-4 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-3">
          <button onClick={() => navigate('/dashboard')} data-testid="back-to-dashboard">
            <ArrowRight className="w-6 h-6 text-white" />
          </button>
          <Logo size="md" />
          <h1 className="text-2xl font-heading font-bold text-white">الموظفين</h1>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {employees.map((emp) => (
            <div
              key={emp.id}
              className="bg-white rounded-lg p-6 shadow-sm border border-gray-100 hover-lift"
              data-testid={`employee-card-${emp.id}`}
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gold rounded-full flex items-center justify-center">
                  <Briefcase className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-heading font-semibold text-primary mb-1">
                    {emp.full_name}
                  </h3>
                  <span className="inline-block px-3 py-1 bg-blue-100 text-blue-700 text-xs rounded-full font-body">
                    {getRoleName(emp.role)}
                  </span>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Mail className="w-4 h-4" />
                  <span className="font-body">{emp.email}</span>
                </div>
                {emp.phone && (
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <Phone className="w-4 h-4" />
                    <span className="font-body">{emp.phone}</span>
                  </div>
                )}
                {emp.department && (
                  <div className="text-sm text-gray-600 font-body">
                    <strong>القسم:</strong> {emp.department}
                  </div>
                )}
                <p className="text-xs text-gray-500 mt-2 font-body">
                  تاريخ الانضمام: {new Date(emp.created_at).toLocaleDateString('ar-EG')}
                </p>
              </div>
            </div>
          ))}
        </div>

        {employees.length === 0 && (
          <div className="text-center py-16" data-testid="no-employees">
            <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 font-body">لا يوجد موظفين حالياً</p>
          </div>
        )}
      </main>
    </div>
  );
}
